import { SelectItem } from '../../types';

export const ACTION = {
  CLEAR_AGGREGATION_STATE: 'SELECTION_REPORT:CLEAR_AGGREGATION_STATE',
  REQUEST_AGGREGATE_FIELDS: 'SELECTION_REPORT:REQUEST_AGGREGATE_FIELDS',
  RESPONSE_AGGREGATE_FIELDS: 'SELECTION_REPORT:RESPONSE_AGGREGATE_FIELDS',
  REQUEST_AGGREGATE_DEFAULT_FIELDS: 'SELECTION_REPORT:REQUEST_AGGREGATE_DEFAULT_FIELDS',
  RESPONSE_AGGREGATE_DEFAULT_FIELDS: 'SELECTION_REPORT:RESPONSE_AGGREGATE_DEFAULT_FIELDS',
  UPDATE_DEFAULT_AGGREGATE_FIELDS: 'SELECTION_REPORT:UPDATE_DEFAULT_AGGREGATE_FIELDS',
  REQUEST_AGGREGATE_FUNC_OPTIONS: 'SELECTION_REPORT:REQUEST_AGGREGATE_FUNCTION_OPTIONS',
  SET_OPTIONS: 'SELECTION_REPORT:SET_OPTIONS'
};

export class ClearAggregationState {
  public type: string = ACTION.CLEAR_AGGREGATION_STATE;
  constructor(public instanceKey: string) {}
}
export class RequestAggregateDefaultFields {
  public type: string = ACTION.REQUEST_AGGREGATE_DEFAULT_FIELDS;
  constructor(public instanceKey: string) {}
}
export class ResponseAggregateDefaultFields {
  public type: string = ACTION.RESPONSE_AGGREGATE_DEFAULT_FIELDS;
  constructor(public instanceKey: string, public options: SelectItem[]) { }
}
export class UpdateAggregateDefaultFields {
  public type: string = ACTION.UPDATE_DEFAULT_AGGREGATE_FIELDS;
  constructor(public instanceKey: string, public options: SelectItem[]) { }
}
export class ResponseAggregateFields {
  public type: string = ACTION.RESPONSE_AGGREGATE_FIELDS;
  constructor(public instanceKey: string, public options: SelectItem[]) { }
}
export class RequestAggregateFunctionOptions {
  public type: string = ACTION.REQUEST_AGGREGATE_FUNC_OPTIONS;
  constructor(public instanceKey: string) {}
}

export class SetOptions {
  public type: string = ACTION.SET_OPTIONS;
  constructor(
    public instanceKey: string, 
    public aggregateFunctionOptions: SelectItem[], 
    public uomSetOptions: SelectItem[]
  ) {}
}
